import { render, staticRenderFns } from "./editrecieveaddress.vue?vue&type=template&id=7fcb08ea"
import script from "./editrecieveaddress.vue?vue&type=script&lang=js"
export * from "./editrecieveaddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports